var _circle, _path, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.45,
    stroke: "#3E404D",
    strokeWidth: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3161 11C16.3161 13.9656 15.6739 16.6231 14.6625 18.5194C13.6386 20.4392 12.3175 21.45 10.9995 21.45C9.68145 21.45 8.36035 20.4392 7.33641 18.5194C6.32508 16.6231 5.68281 13.9656 5.68281 11C5.68281 8.03444 6.32508 5.3769 7.33641 3.48065C8.36035 1.56076 9.68145 0.55 10.9995 0.55C12.3175 0.55 13.6386 1.56076 14.6625 3.48065C15.6739 5.3769 16.3161 8.03444 16.3161 11Z",
    stroke: "#3E404D",
    strokeWidth: 1.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.1834,
    y1: 21.45,
    x2: 11.1834,
    y2: 0.549999,
    stroke: "#3E404D",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.45,
    y1: 10.8176,
    x2: 0.549999,
    y2: 10.8176,
    stroke: "#3E404D",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9842,
    y1: 5.68281,
    x2: 2.01751,
    y2: 5.68281,
    stroke: "#3E404D",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9842,
    y1: 15.9504,
    x2: 2.01751,
    y2: 15.9504,
    stroke: "#3E404D",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/lang-icon.f9934c8dd3503cdec4ac77c37614ba5a.svg";
export { ForwardRef as ReactComponent };